import type { FormEvent } from "react";

import { trpc } from "@blis/trpc/react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogCloseButton,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Label, TextArea, TextField } from "@/components/ui/field";
import { Form } from "@/components/ui/form";
import { Modal } from "@/components/ui/modal";
import { toast } from "@/components/ui/toast";
import { useDialogProps } from "../detail/state";

type HoldDialogProps = {
  accession: { id: number };
};

export function HoldDialog({ accession }: HoldDialogProps) {
  const { mutate, isPending } = trpc.holds.create.useMutation();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const target = e.target as HTMLFormElement;
    const formData = new FormData(target);
    const values = Object.fromEntries(formData.entries());

    mutate(
      {
        accessionId: accession.id,
        description: values.description as string,
      },
      {
        onSuccess() {
          toast.success("Hold created");
          dialogProps.onOpenChange?.(false);
          target.reset();
        },
        onError(err) {
          toast.error(`Error creating hold: ${err.message}`);
        },
      },
    );
  };
  const dialogProps = useDialogProps("hold");

  return (
    <Modal isOpen={dialogProps.open} onOpenChange={dialogProps.onOpenChange}>
      <Dialog>
        <DialogHeader>
          <DialogTitle>Create hold</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <Form onSubmit={onSubmit} id="hold-form">
            <TextField name="description" isRequired>
              <Label>Reason for hold</Label>
              <TextArea placeholder="Enter reason" />
            </TextField>
          </Form>
        </DialogBody>
        <DialogFooter>
          <Button type="submit" form="hold-form" isPending={isPending}>
            Submit
          </Button>
          <DialogCloseButton>Cancel</DialogCloseButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
